export const defaultActivityFormValues = {
  venueTypeCode: '',
  socialUrls: [{ url: '' }],
  targetCustomer: {
    individual: false,
    educational: false,
  },
  phoneNumber: '',
}
